<template>
  <div v-if="row && row.status !== 'approved'" class="isb" :class="'isb--' + row.status" role="status">
    <i class="fe isb-icon" :class="row.status === 'pending' ? 'fe-clock' : 'fe-alert-triangle'"></i>
    <div>
      <strong class="d-block">{{ heading }}</strong>
      <span>{{ text }}</span>
    </div>
    <router-link v-if="showLink" to="/my-practice" class="btn btn-sm btn-light ml-auto">My practice</router-link>
  </div>
</template>

<script>
// Shown to independent facilities until a platform admin approves them (backend IndependentProviders::refusal).
import { independent, refreshIndependent } from "@/service/independent";

export default {
  name: "IndependentStatusBanner",
  props: {
    summary: { type: Object, default: null }, // pass to skip the refresh
    showLink: { type: Boolean, default: false },
  },
  data() {
    return { own: independent() };
  },
  computed: {
    row() {
      return this.summary || this.own;
    },
    heading() {
      if (this.row.status === "pending") return "Your facility is awaiting approval";
      if (this.row.status === "suspended") return "Your facility is suspended";
      return "Your facility registration was not approved";
    },
    text() {
      if (this.row.status === "pending") {
        return "Set up your price list, staff and consultation hours meanwhile. Enrolling patients, encounters, consultations and orders open once we approve you.";
      }
      return this.row.status_reason || "Contact Claimify support for details.";
    },
  },
  created() {
    if (!this.summary && this.own) {
      refreshIndependent(this.axios).then((s) => { this.own = s; });
    }
  },
};
</script>

<style scoped>
.isb { display: flex; align-items: center; gap: 14px; border-radius: 14px; padding: 14px 18px; }
.isb--pending { background: #fffbeb; border: 1px solid #fde68a; color: #92400e; }
.isb--rejected, .isb--suspended { background: #fef2f2; border: 1px solid #fecaca; color: #991b1b; }
.isb-icon { font-size: 1.5rem; }
</style>
